import { useCallback, useContext } from "react";
import { AuthContext } from "@/providers/AuthProvider";
import {
  signIn,
  signOut,
} from "@/services/approveshield/api/auth";

export const useAuth = () => {
  const { user, setUser, authenticating } = useContext(AuthContext);

  const login = useCallback(
    async ({ email, password }) => {
      const res = await signIn({ email, password });
      if (res?.success) {
        setUser(res.data);
      }
      return res;
    },
    [setUser]
  );

  const logout = useCallback(async () => {
    const res = await signOut();
    if (res?.success) {
      console.log("Logged Out Successfully", res);
      setUser(null);
    }
    return res;
  }, [setUser]);

  return {
    user,
    authenticating,
    loggedIn: !!user,
    login,
    logout,
  };
};
